import {connect} from "react-redux";
import {SecurityComponent} from "../../pages/components/SecurityComponent";
import {fetchUserSecurityConfiguration, postUserSecurityProfile} from "../apicalls/SecurityConfigurationCalls";


const mapStateToProps = (state, ownProps) => {
    const { user, userSecurityProfile } = state;
    const { container } = ownProps;
    return {
        user,
        userSecurityProfile,
        container
    }
};

const mapDispatchToProps = dispatch => {
    return {
        postSecurityConfig: (securityConfiguration) => {
            dispatch(postUserSecurityProfile(securityConfiguration))
        }
    }
};

export const SecurityAdapter = connect(mapStateToProps, mapDispatchToProps)(SecurityComponent);